var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#620FEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9067_72137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50337 7.73727L7.37753 7.07453L4 9.06273V13.0255L7.37753 15.0068L10.7551 13.0255V6.86273L12.6292 5.76273L14.5034 6.86273V9.06273L12.6292 10.1627L11.5034 9.5V11.2627L12.6292 11.9255L16.0067 9.9441V5.98137L12.6292 4L9.25169 5.98137V12.1441L7.37753 13.2441L5.50337 12.1441V9.93727L7.37753 8.83727L8.50337 9.5V7.73727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9067_72137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.d29777d84fbd83aec924e9575c1a87e0.svg";
export { ForwardRef as ReactComponent };